/* eslint-disable @typescript-eslint/no-explicit-any */
type FieldRef = {
  form: any;
  fieldPath: string;
};

class ViolationSyncRegistry {
  private registry = new Map<string, Set<FieldRef>>();

  private syncingFrom = new Set<string>();

  register(violationId: string, fieldRef: FieldRef) {
    if (!this.registry.has(violationId)) {
      this.registry.set(violationId, new Set());
    }
    this.registry.get(violationId)!.add(fieldRef);
  }

  unregister(violationId: string, fieldRef: FieldRef) {
    const refs = this.registry.get(violationId);

    if (refs) {
      refs.delete(fieldRef);
      if (refs.size === 0) this.registry.delete(violationId);
    }
  }

  syncField(violationId: string, sourceFieldPath: string, propertyPath: string, newValue: any) {
    const refs = this.registry.get(violationId);

    if (!refs) return;

    const originKey = `${violationId}:${sourceFieldPath}`;

    if (this.syncingFrom.has(originKey)) return;

    this.syncingFrom.add(originKey);

    try {
      refs.forEach(ref => {
        if (ref.fieldPath !== sourceFieldPath) {
          const fieldName = `${ref.fieldPath}.${propertyPath}`;

          ref.form.mutators.setFieldSilent(fieldName, newValue);
        }
      });
    } finally {
      setTimeout(() => this.syncingFrom.delete(originKey), 0);
    }
  }
}

export const violationSyncRegistry = new ViolationSyncRegistry();
